
export const serviceChannelUploadEditColumnDef = [
  { "headerName": "Errors", "field": "errors", filter: 'agTextColumnFilter' },
  { "headerName": "Order No", "field": "orderNo", filter: 'agTextColumnFilter' },
  { "headerName": "Order Date", "field": "orderDate", filter: 'agTextColumnFilter' },
  { "headerName": "Payment No", "field": "paymentNo", filter: 'agTextColumnFilter' },
  { "headerName": "TP Brokrage %", "field": "tpBrokragePc", filter: 'agTextColumnFilter' },
  { "headerName": "TP Brokrage Amt", "field": "tpBrokrageAmt", filter: 'agTextColumnFilter' },
  { "headerName": "Brokrage PC", "field": "brokragePc", filter: 'agTextColumnFilter' },
  { "headerName": "Brokrage Amt", "field": "brokrageAmt", filter: 'agTextColumnFilter' },
  { "headerName": "TP Reward Amt", "field": "tpRewardAmt", filter: 'agTextColumnFilter' },
  { "headerName": "Reward PC", "field": "rewardPC", filter: 'agTextColumnFilter' },
  { "headerName": "Reward Amt", "field": "rewardAmt", filter: 'agTextColumnFilter' },


]

	
